/**
 * 销售占比打印配置
 * 参照报表打印调用文档，字段与模板 BILL_CONFIGS.SALE_RATIO 绑定
 */

import { getLoginName } from '@/utils/util'

export const BILL_TYPE = 'SALE_RATIO'
export const REPORT_TITLE = '销售占比'

// 表格列定义
export const defColumns = [
  {
    title: '序号', dataIndex: 'rowIndex', width: 60, align: 'center',
    customRender: function (t, r, index) {
      return (t !== '合计') ? (parseInt(index) + 1) : t
    }
  },
  { title: '商品名称', dataIndex: 'mName', width: 160, ellipsis: true },
  { title: '类别名称', dataIndex: 'categoryName', width: 120, ellipsis: true },
  { title: '销售数量', dataIndex: 'allNum', width: 100, align: 'right' },
  {
    title: '销售金额', dataIndex: 'allPrice', width: 120, align: 'right',
    customRender: function (t) {
      return t != null ? '￥' + parseFloat(t).toFixed(2) : '￥0.00'
    }
  },
  { title: '销售占比', dataIndex: 'ratio', width: 100, align: 'right' }
]

// 打印数据构建 - 将列表数据 + 查询条件映射为打印字段
export function buildPrintData(dataSource, queryParam, userInfo, companyInfo) {
  // 步骤1：从 dataSource 末尾提取合计行（tableAddTotalRow 已追加）
  const totalRow = (dataSource || []).find(item => item.rowIndex === '合计')
  const totalAllNum = totalRow ? Number(totalRow.allNum || 0) : 0
  const totalAllPrice = totalRow ? Number(totalRow.allPrice || 0) : 0

  // 步骤2：过滤合计行，映射数据行
  const rows = (dataSource || [])
    .filter(item => item.rowIndex !== '合计')
    .map((item, idx) => ({
      rowIndex: idx + 1,
      mName: item.mName || '',
      categoryName: item.categoryName || '',
      allNum: item.allNum || 0,
      allPrice: item.allPrice || 0,
      ratio: item.ratio || ''
    }))

  // 步骤3：追加合计行到表格末尾
  if (totalRow) {
    rows.push({
      rowIndex: '合计',
      mName: '',
      categoryName: '',
      allNum: totalAllNum,
      allPrice: totalAllPrice,
      ratio: ''
    })
  }

  return {
    // 单据主体 — 字段名与模板 BILL_CONFIGS.SALE_RATIO headerGroup 绑定
    reportTitle: REPORT_TITLE,
    reportDate: new Date().toLocaleDateString(),
    dateRange: (queryParam && queryParam.beginTime && queryParam.endTime)
      ? queryParam.beginTime + ' ~ ' + queryParam.endTime : '',
    categoryName: (queryParam && queryParam.categoryName) || '',
    creatorName: getLoginName(),
    totalAllNum: totalAllNum,
    totalAllPrice: totalAllPrice,
    // 单据明细 — 字段名 table 与模板表格元素 field: "table" 绑定
    table: rows,
    // 公司信息 / 其它信息
    companyName: (companyInfo && companyInfo.companyName) || '',
    companyAddress: (companyInfo && companyInfo.companyAddress) || '',
    companyTel: (companyInfo && companyInfo.companyTel) || '',
    companyFax: (companyInfo && companyInfo.companyFax) || ''
  }
}